import { useState } from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';

interface SignedInAsBarProps {
  returnTo: string;
}

export function SignedInAsBar({ returnTo }: SignedInAsBarProps) {
  const { user, logout } = useAuth();
  const [switching, setSwitching] = useState(false);

  if (!user) return null;

  const label = user.email || [user.firstName, user.lastName].filter(Boolean).join(' ') || 'this account';

  const handleSwitchAccount = async () => {
    if (switching) return;
    setSwitching(true);
    try {
      await logout();
    } finally {
      window.location.href = `/auth?mode=signin&returnTo=${encodeURIComponent(returnTo)}`;
    }
  };

  return (
    <div
      className="flex items-center justify-between gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2 mb-3"
      data-testid="bar-signed-in-as"
    >
      <p className="text-xs text-gray-500 truncate">
        Signed in as <span className="font-semibold text-gray-700">{label}</span>
      </p>
      <button
        onClick={handleSwitchAccount}
        disabled={switching}
        className="flex items-center gap-1 text-xs font-semibold text-emerald-700 whitespace-nowrap disabled:opacity-50"
        data-testid="button-switch-account"
      >
        <LogOut className="w-3.5 h-3.5" />
        {switching ? 'Switching…' : 'Switch account'}
      </button>
    </div>
  );
}
